var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"notfound"}},[_c('div',{staticClass:"notfound"},[_vm._m(0),_c('h2',[_vm._v(_vm._s(_vm.nameError))]),_c('p',[_vm._v(_vm._s(_vm.desError))]),_c('a',{attrs:{"href":"/"}},[_vm._v("Go To Homepage")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfound-404"},[_c('h1',[_vm._v("Oops!")])])
}]

export { render, staticRenderFns }